/** Runs `fn`, swallowing anything it throws: tracking must never break the app. */
// eslint-disable-next-line import/prefer-default-export
export const safely = (fn: () => void) => {
  try {
    fn();
  } catch {
    /* empty */
  }
};
